// authService.ts
import { post } from '../../common/axiosClient';

const login = (email: string, password: string) => post('/user/login', { email, password });
const register = (email: string, firstName: string, lastName: string, roles: string[]) =>
  post('/user/register', { email, firstName, lastName, roles });
const logout = () => post('/user/logout', {});

const authService = {
  login,
  register,
  logout,
};

export default authService;
